import { render, staticRenderFns } from "./LawProfessionalInvestigationTypeList.vue?vue&type=template&id=1cce44d2&"
import script from "./LawProfessionalInvestigationTypeList.vue?vue&type=script&lang=js&"
export * from "./LawProfessionalInvestigationTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawProfessionalInvestigationTypeList.vue?vue&type=style&index=0&id=1cce44d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports